export const ROUTE_TITLES = {
  "/dashboard": "Dashboard",
  "/aibot": "Live Coaching",
  "/analytics": "Analytics",
  "/tables": "Users",
  "/tags": "Tags",
  "/subscriptions": "Subscriptions",
  "/reports": "Reports",
  "/content-management": "Content",
  "/billing": "Payment",
  "/profile": "Profile",
};

export const getRouteTitle = (pathname, fallback = "") => ROUTE_TITLES[pathname] || fallback;
